import { storageUtil } from '@/utils'

export function tbodyScroll(curEvent, ctx) {
    if (curEvent == null) {
        return
    }
    const tbodyDom = ctx.refs.tbody
    if (tbodyDom != null) {
        (tbodyDom as HTMLElement).scrollTo(curEvent.scrollLeft || 0, curEvent.scrollTop || 0)
    }
}

export const {
    isInStorage,
    getDataFromStorage,
    setDataFromStorage,
    toggleDataFromStorage,
    clearDataFromStorage,
    deleteDataFromStorage
} = storageUtil('session')
